import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const GraphicAd = () => {
  return (
    <div className="relative">
      {/* Scroll Banner Créatif pour Collections en Promo */}
      <div className="overflow-hidden">
        <motion.div
          className="relative bg-gradient-to-r from-purple-600 via-pink-600 to-red-600 py-4 lg:py-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          {/* Effet de brillance animé */}
          <motion.div
            className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
            animate={{ x: ['-100%', '200%'] }}
            transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
          />
          
          {/* Contenu défilant */}
          <div className="relative flex">
            <motion.div
              className="flex space-x-8 lg:space-x-12 whitespace-nowrap"
              animate={{ x: ['0%', '-50%'] }}
              transition={{ 
                duration: 30, 
                repeat: Infinity, 
                ease: "linear" 
              }}
            >
              {/* Dupliquer pour un défilement infini */}
              {[...Array(2)].map((_, i) => (
                <div key={i} className="flex space-x-8 lg:space-x-12">
                  <div className="flex items-center space-x-2 lg:space-x-3">
                    <Icon name="Zap" className="text-white" size={16} />
                    <span className="text-white font-black text-sm lg:text-2xl uppercase tracking-wider">
                      Collections Exclusives en Promo
                    </span>
                  </div>
                  <div className="flex items-center space-x-2 lg:space-x-3">
                    <Icon name="Gift" className="text-white" size={16} />
                    <span className="text-white font-black text-sm lg:text-2xl uppercase tracking-wider">
                      Jusqu'à -70% de Réduction
                    </span>
                  </div>
                  <div className="flex items-center space-x-2 lg:space-x-3">
                    <Icon name="Star" className="text-white" size={16} />
                    <span className="text-white font-black text-sm lg:text-2xl uppercase tracking-wider">
                      Offres Limitées
                    </span>
                  </div>
                  <div className="flex items-center space-x-2 lg:space-x-3">
                    <Icon name="TrendingUp" className="text-white" size={16} />
                    <span className="text-white font-black text-sm lg:text-2xl uppercase tracking-wider">
                      Nouveautés en Solde
                    </span>
                  </div>
                  <div className="flex items-center space-x-2 lg:space-x-3">
                    <Icon name="Heart" className="text-white" size={16} />
                    <span className="text-white font-black text-sm lg:text-2xl uppercase tracking-wider">
                      Coups de Cœur à Prix Réduits
                    </span>
                  </div>
                  <div className="flex items-center space-x-2 lg:space-x-3">
                    <Icon name="ShoppingBag" className="text-white" size={16} />
                    <span className="text-white font-black text-sm lg:text-2xl uppercase tracking-wider">
                      Livraison Gratuite
                    </span>
                  </div>
                </div>
              ))}
            </motion.div>
          </div>
          
          {/* Bordures décoratives */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-white/0 via-white/50 to-white/0"></div>
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-white/0 via-white/50 to-white/0"></div>
        </motion.div>
      </div>

      {/* Images Publicitaires Verticales */}
      <div className="space-y-0">
        {/* Image 1 - graphicAd1.png */}
        <motion.div
          className="relative w-full overflow-hidden rounded-none lg:rounded-3xl group cursor-pointer"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          whileHover={{ scale: 1.02 }}
        >
          {/* Conteneur avec effet de lumière au survol */}
          <div className="relative overflow-hidden rounded-none lg:rounded-3xl border-0 lg:border-4 border-white/10 shadow-2xl">
            <img
              src="/graphicAd1.png"
              alt="Promotion Spéciale 1"
              className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105"
            />
            
            {/* Overlay gradient au survol */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            
            {/* Effet de brillance au survol */}
            <motion.div
              className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent opacity-0 group-hover:opacity-100"
              animate={{ x: ['-100%', '200%'] }}
              transition={{ duration: 1.5, repeat: Infinity, repeatDelay: 1 }}
            />
            
            {/* Badge flottant */}
            <motion.div
              className="absolute top-3 right-3 lg:top-6 lg:right-6 bg-gradient-to-r from-error to-warning rounded-full px-3 py-1.5 lg:px-6 lg:py-3 shadow-2xl border border-white/30 lg:border-2"
              animate={{ 
                y: [0, -10, 0],
                rotate: [0, 5, -5, 0]
              }}
              transition={{ duration: 3, repeat: Infinity }}
            >
              <div className="flex items-center space-x-1 lg:space-x-2">
                <Icon name="Zap" className="text-white" size={14} />
                <span className="text-white font-black text-xs lg:text-sm uppercase">Promo Exclusive</span>
              </div>
            </motion.div>
          </div>
          
          {/* Bordure lumineuse animée */}
          <motion.div
            className="hidden lg:block absolute -inset-1 bg-gradient-to-r from-accent via-error to-warning rounded-3xl opacity-0 group-hover:opacity-50 blur-xl -z-10"
            animate={{
              backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'],
            }}
            transition={{ duration: 3, repeat: Infinity }}
            style={{ backgroundSize: '200% 200%' }}
          />
        </motion.div>

        {/* Image 2 - graphicAd2.png */}
        <motion.div
          className="relative w-full overflow-hidden rounded-none lg:rounded-3xl group cursor-pointer"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          whileHover={{ scale: 1.02 }}
        >
          {/* Conteneur avec effet de lumière au survol */}
          <div className="relative overflow-hidden rounded-none lg:rounded-3xl border-0 lg:border-4 border-white/10 shadow-2xl">
            <img
              src="/graphicAd2.png"
              alt="Promotion Spéciale 2"
              className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105"
            />
            
            {/* Overlay gradient au survol */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            
            {/* Effet de brillance au survol */}
            <motion.div
              className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent opacity-0 group-hover:opacity-100"
              animate={{ x: ['-100%', '200%'] }}
              transition={{ duration: 1.5, repeat: Infinity, repeatDelay: 1 }}
            />
            
            {/* Badge flottant */}
            <motion.div
              className="absolute top-3 left-3 lg:top-6 lg:left-6 bg-gradient-to-r from-success to-accent rounded-full px-3 py-1.5 lg:px-6 lg:py-3 shadow-2xl border border-white/30 lg:border-2"
              animate={{ 
                y: [0, -10, 0],
                rotate: [0, -5, 5, 0]
              }}
              transition={{ duration: 3, repeat: Infinity }}
            >
              <div className="flex items-center space-x-1 lg:space-x-2">
                <Icon name="Star" className="text-white" size={14} />
                <span className="text-white font-black text-xs lg:text-sm uppercase">Offre Limitée</span>
              </div>
            </motion.div>
          </div>
          
          {/* Bordure lumineuse animée */}
          <motion.div
            className="hidden lg:block absolute -inset-1 bg-gradient-to-r from-success via-accent to-error rounded-3xl opacity-0 group-hover:opacity-50 blur-xl -z-10"
            animate={{
              backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'],
            }}
            transition={{ duration: 3, repeat: Infinity }}
            style={{ backgroundSize: '200% 200%' }}
          />
        </motion.div>
      </div>
    </div>
  );
};

export default GraphicAd;
